"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumb = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _Icon = require("../Icon");

var _Link = require("../Link");

var _excluded = ["children", "linkWrapper"];
var BreadcrumbLink = ( /*#__PURE__*/0, _theming.styled)(_Link.Link, process.env.NODE_ENV === "production" ? {
  target: "e11xxs1v2"
} : {
  target: "e11xxs1v2",
  label: "BreadcrumbLink"
})("font-size:", _styles.typography.size.s2, "px;line-height:", _styles.typography.size.m1, "px;margin-top:16px;margin-bottom:16px;@media (min-width: ", _styles.breakpoint * 1.333, "px){margin-top:0;margin-bottom:24px;}");
var BreadcrumbInner = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e11xxs1v1"
} : {
  target: "e11xxs1v1",
  label: "BreadcrumbInner"
})("@media (min-width: ", _styles.breakpoint * 1.333, "px){margin-top:-1rem;}");
var BreadcrumbIcon = ( /*#__PURE__*/0, _theming.styled)(_Icon.Icon, process.env.NODE_ENV === "production" ? {
  target: "e11xxs1v0"
} : {
  target: "e11xxs1v0",
  label: "BreadcrumbIcon"
})("color:", _styles.color.mediumdark, ";");

var Breadcrumb = function Breadcrumb(_ref) {
  var children = _ref.children,
      linkWrapper = _ref.linkWrapper,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(BreadcrumbInner, null, /*#__PURE__*/_react["default"].createElement(BreadcrumbLink, (0, _extends2["default"])({
    tertiary: true,
    LinkWrapper: linkWrapper
  }, props), /*#__PURE__*/_react["default"].createElement(BreadcrumbIcon, {
    icon: "arrowleft"
  }), children));
};

exports.Breadcrumb = Breadcrumb;